import partialProducts from "./partial-products.json";
import { filters, defaultFilterIndex } from "./filters.json";

export { partialProducts, filters };
export const defaultFilter = filters[defaultFilterIndex];

export const getProduct = id => fetch(`/products-data/product-${id}.json`).then(res => res.json());